import { render, staticRenderFns } from "./code_block.vue.js?vue&type=template&id=60d24716!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./code_block.vue?vue&type=template&id=60d24716"
import script from "./code_block.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./code_block.vue?vue&type=script&lang=js"
export * from "./code_block.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./code_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports